import { DonorType, OrganType } from '@/api/apis/case';
import { HeartDonorProfileForm } from './HeartDonorProfileForm';
import { LiverDonorProfileForm } from './LiverDonorProfileForm';
import { LungsDonorProfileForm } from './LungsDonorProfileForm';

type DonorProfileFormProps = {
  organType?: OrganType | null;
  /** DCD-only Neuro Status. Omit to always show it. */
  donorType?: DonorType | null;
};

export const DonorProfileForm = ({ organType, donorType }: DonorProfileFormProps) => {
  switch (organType) {
    case OrganType.Liver:
      return <LiverDonorProfileForm donorType={donorType} />;
    case OrganType.Heart:
      return <HeartDonorProfileForm donorType={donorType} />;
    case OrganType.Lungs:
      return <LungsDonorProfileForm donorType={donorType} />;
    default:
      return null;
  }
};
